import { createFileRoute, redirect } from "@tanstack/react-router";

// Root entry → send to the localized login (single locale "nl" for now).
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/login",
      params: { locale: "nl", schoolyear: undefined },
    });
  },
});
